import { render, staticRenderFns } from "./NRSJYKMZ.vue?vue&type=template&id=3964b018&scoped=true&"
import script from "./NRSJYKMZ.vue?vue&type=script&lang=js&"
export * from "./NRSJYKMZ.vue?vue&type=script&lang=js&"
import style0 from "./NRSJYKMZ.vue?vue&type=style&index=0&id=3964b018&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3964b018",
  null
  
)

export default component.exports